import { imgixHost } from 'src/config'
import Model, { ID, Integer, MODEL_LEVEL } from 'src/models/Model'

export default class ShowingBadge extends Model {
  static name = 'ShowingBadge'

  static isConfiguration = true

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Circuit, Model.permissionCategories.Ticketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      displayName: {
        type: String,
        required: true,
        translatable: true
      },
      type: {
        type: String,
        options: ['name', 'icon', 'name-and-icon'],
        default: 'name'
      },
      iconName: {
        type: String,
        options: ['child_care', 'child_friendly', 'escalator_warning', 'family_restroom', 'nature_people', 'event_seat', 'accessible', 'weekend', 'local_movies', 'fastfood', 'add_shopping_cart', 'stay_current_landscape', 'local_bar', 'movie', 'theaters', 'emoji_events']
      },
      iconImage: {
        type: String,
        required: false,
        default: null
      },
      iconImageParams: {
        type: String,
        default: 'w=auto&h=128&fit=fill&fill=solid&auto=format',
        local: true
      },
      iconImagePreviewParams: {
        type: String,
        default: 'w=30&h=30&fit=fill&fill=solid&transparency=grid&auto=format',
        local: true
      },
      title: {
        type: String,
        required: true,
        translatable: true
      },
      color: {
        type: String,
        required: false,
        default: null
      },
      description: {
        type: String,
        default: '',
        translatable: true
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      conferPriority: {
        type: Boolean,
        default: false
      },
      tmsTag: {
        type: String,
        required: false,
        default: null
      },
      tmsTemplate: {
        type: String,
        required: false,
        default: null
      },
      isButtonOnly: {
        type: Boolean,
        default: false
      },
      displayTitleOnButton: {
        type: Boolean,
        default: false
      },
      displayOnSignage: {
        type: Boolean,
        required: false,
        default: false
      }
    }

    this.computed = {
      class () {
        return _.kebabCase(this.title)
      },
      iconImageUrl () {
        if (!this.iconImage) return ''

        return `${imgixHost}/${this.iconImage}?${this.iconImageParams}`
      },
      iconImagePreviewUrl () {
        if (!this.iconImage) return ''

        return `${imgixHost}/${this.iconImage}?${this.iconImagePreviewParams}`
      }
    }

    this.fragments = {
      select: ['id', 'title', 'color']
    }
  }
}
